import { Component, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { CardComponent } from '@app/ui-components/card/card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-section-i',
  imports: [TranslatePipe, CardComponent],
  templateUrl: './project-details-section-i.component.html',
  styleUrl: './project-details-section-i.component.scss',
})
export class ProjectDetailsSectionIComponent {
  projectDetails = input.required<ProjectPublicResponse>();
  protected translationKey = 'projectDetails.sectionI.';
}
